import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import './media/extensionsWidgets.css.js';
import { semverExports } from 'vscode/external/vscode-semver/semver.js';
import { Disposable, DisposableStore, toDisposable, MutableDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IExtensionsWorkbenchService } from 'vscode/vscode/vs/workbench/contrib/extensions/common/extensions.service';
import { addDisposableListener, EventType, finalHandler, append, $, reset } from 'vscode/vscode/vs/base/browser/dom';
import { language } from 'vscode/vscode/vs/base/common/platform';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { IExtensionManagementServerService } from 'vscode/vscode/vs/workbench/services/extensionManagement/common/extensionManagement.service';
import { IExtensionRecommendationsService, IExtensionIgnoredRecommendationsService } from 'vscode/vscode/vs/workbench/services/extensionRecommendations/common/extensionRecommendations.service';
import { ILabelService } from 'vscode/vscode/vs/platform/label/common/label.service';
import { extensionButtonProminentBackground } from 'vscode/vscode/vs/workbench/contrib/extensions/browser/extensionsActions';
import { registerThemingParticipant } from 'vscode/vscode/vs/platform/theme/common/themeService';
import { IThemeService } from 'vscode/vscode/vs/platform/theme/common/themeService.service';
import { ThemeIcon } from 'vscode/vscode/vs/base/common/themables';
import { EXTENSION_BADGE_REMOTE_BACKGROUND, EXTENSION_BADGE_REMOTE_FOREGROUND } from 'vscode/vscode/vs/workbench/common/theme';
import { Event, Emitter } from 'vscode/vscode/vs/base/common/event';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { CountBadge } from 'vscode/vscode/vs/base/browser/ui/countBadge/countBadge';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { IUserDataSyncEnablementService } from 'vscode/vscode/vs/platform/userDataSync/common/userDataSync.service';
import { installCountIcon, starFullIcon, starHalfIcon, starEmptyIcon, verifiedPublisherIcon, sponsorIcon, ratingIcon, preReleaseIcon, remoteIcon, syncIgnoredIcon, activationTimeIcon, errorIcon, warningIcon, infoIcon } from 'vscode/vscode/vs/workbench/contrib/extensions/browser/extensionsIcons';
import { registerColor } from 'vscode/vscode/vs/platform/theme/common/colorUtils';
import { textLinkForeground } from 'vscode/vscode/vs/platform/theme/common/colors/baseColors';
import 'vscode/vscode/vs/platform/theme/common/colors/chartsColors';
import 'vscode/vscode/vs/platform/theme/common/colors/editorColors';
import 'vscode/vscode/vs/platform/theme/common/colors/inputColors';
import 'vscode/vscode/vs/platform/theme/common/colors/listColors';
import 'vscode/vscode/vs/platform/theme/common/colors/menuColors';
import 'vscode/vscode/vs/platform/theme/common/colors/minimapColors';
import 'vscode/vscode/vs/platform/theme/common/colors/miscColors';
import 'vscode/vscode/vs/platform/theme/common/colors/quickpickColors';
import 'vscode/vscode/vs/platform/theme/common/colors/searchColors';
import { IHoverService } from 'vscode/vscode/vs/platform/hover/browser/hover.service';
import { MarkdownString } from 'vscode/vscode/vs/base/common/htmlContent';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import { IExtensionService } from 'vscode/vscode/vs/workbench/services/extensions/common/extensions.service';
import { areSameExtensions } from 'vscode/vscode/vs/platform/extensionManagement/common/extensionManagementUtil';
import Severity$1 from 'vscode/vscode/vs/base/common/severity';
import { Color } from 'vscode/vscode/vs/base/common/color';
import { renderMarkdown } from 'vscode/vscode/vs/base/browser/markdownRenderer';
import { IOpenerService } from 'vscode/vscode/vs/platform/opener/common/opener.service';
import { onUnexpectedError } from 'vscode/vscode/vs/base/common/errors';
import { renderIcon } from 'vscode/vscode/vs/base/browser/ui/iconLabel/iconLabels';
import { StandardKeyboardEvent } from 'vscode/vscode/vs/base/browser/keyboardEvent';
import { ITelemetryService } from 'vscode/vscode/vs/platform/telemetry/common/telemetry.service';
import { defaultCountBadgeStyles } from 'vscode/vscode/vs/platform/theme/browser/defaultStyles';
import { getDefaultHoverDelegate } from 'vscode/vscode/vs/base/browser/ui/hover/hoverDelegateFactory';
import { IWorkspaceContextService } from 'vscode/vscode/vs/platform/workspace/common/workspace.service';

var ExtensionHoverWidget_1;
const _moduleId = "vs/workbench/contrib/extensions/browser/extensionsWidgets";
class ExtensionWidget extends Disposable {
    constructor() {
        super(...arguments);
        this._extension = null;
    }
    get extension() { return this._extension; }
    set extension(extension) { this._extension = extension; this.update(); }
    update() { this.render(); }
}
function onClick(element, callback) {
    const disposables = ( (new DisposableStore()));
    disposables.add(addDisposableListener(element, EventType.CLICK, finalHandler(callback)));
    disposables.add(addDisposableListener(element, EventType.KEY_UP, e => {
        const keyboardEvent = ( (new StandardKeyboardEvent(e)));
        if (keyboardEvent.equals(10 ) || keyboardEvent.equals(3 )) {
            e.preventDefault();
            e.stopPropagation();
            callback();
        }
    }));
    return disposables;
}
class InstallCountWidget extends ExtensionWidget {
    constructor(container, small) {
        super();
        this.container = container;
        this.small = small;
        container.classList.add('extension-install-count');
        this.render();
    }
    render() {
        this.container.innerText = '';
        if (!this.extension) {
            return;
        }
        if (this.small && this.extension.state !== 3 ) {
            return;
        }
        const installLabel = InstallCountWidget.getInstallLabel(this.extension, this.small);
        if (!installLabel) {
            return;
        }
        append(this.container, $('span' + ThemeIcon.asCSSSelector(installCountIcon)));
        const count = append(this.container, $('span.count'));
        count.textContent = installLabel;
    }
    static getInstallLabel(extension, small) {
        const installCount = extension.installCount;
        if (installCount === undefined) {
            return undefined;
        }
        let installLabel;
        if (small) {
            if (installCount > 1000000) {
                installLabel = `${Math.floor(installCount / 100000) / 10}M`;
            }
            else if (installCount > 1000) {
                installLabel = `${Math.floor(installCount / 1000)}K`;
            }
            else {
                installLabel = String(installCount);
            }
        }
        else {
            installLabel = installCount.toLocaleString(language);
        }
        return installLabel;
    }
}
let RatingsWidget = class RatingsWidget extends ExtensionWidget {
    constructor(container, small, hoverService) {
        super();
        this.container = container;
        this.small = small;
        container.classList.add('extension-ratings');
        if (this.small) {
            container.classList.add('small');
        }
        this.containerHover = this._register(hoverService.setupUpdatableHover(getDefaultHoverDelegate('mouse'), container, ''));
        this.render();
    }
    render() {
        this.container.innerText = '';
        if (!this.extension) {
            return;
        }
        if (this.small && this.extension.state !== 3 ) {
            return;
        }
        if (this.extension.rating === undefined) {
            return;
        }
        if (this.small && !this.extension.ratingCount) {
            return;
        }
        const rating = Math.round(this.extension.rating * 2) / 2;
        this.containerHover.update(( localizeWithPath(_moduleId, 0, "Average rating: {0} out of 5", rating)));
        if (this.small) {
            append(this.container, $('span' + ThemeIcon.asCSSSelector(starFullIcon)));
            const count = append(this.container, $('span.count'));
            count.textContent = String(rating);
        }
        else {
            for (let i = 1; i <= 5; i++) {
                if (rating >= i) {
                    append(this.container, $('span' + ThemeIcon.asCSSSelector(starFullIcon)));
                }
                else if (rating >= i - 0.5) {
                    append(this.container, $('span' + ThemeIcon.asCSSSelector(starHalfIcon)));
                }
                else {
                    append(this.container, $('span' + ThemeIcon.asCSSSelector(starEmptyIcon)));
                }
            }
            if (this.extension.ratingCount) {
                const ratingCountElemet = append(this.container, $('span', undefined, ` (${this.extension.ratingCount})`));
                ratingCountElemet.style.paddingLeft = '1px';
            }
        }
    }
};
RatingsWidget = ( (__decorate([
    ( (__param(2, IHoverService)))
], RatingsWidget)));
let VerifiedPublisherWidget = class VerifiedPublisherWidget extends ExtensionWidget {
    constructor(container, small, hoverService, openerService) {
        super();
        this.container = container;
        this.small = small;
        this.openerService = openerService;
        this.disposables = this._register(( (new DisposableStore())));
        this.containerHover = this._register(hoverService.setupUpdatableHover(getDefaultHoverDelegate('mouse'), container, ''));
        this.render();
    }
    render() {
        reset(this.container);
        this.disposables.clear();
        if (!this.extension?.publisherDomain?.verified) {
            return;
        }
        if (this.extension.resourceExtension) {
            return;
        }
        if (this.extension.local?.source === 'resource') {
            return;
        }
        const publisherDomainLink = ( (URI.parse(this.extension.publisherDomain.link)));
        const verifiedPublisher = append(this.container, $('span.extension-verified-publisher.clickable'));
        append(verifiedPublisher, renderIcon(verifiedPublisherIcon));
        if (!this.small) {
            verifiedPublisher.tabIndex = 0;
            this.containerHover.update(`Verified Domain: ${this.extension.publisherDomain.link}`);
            verifiedPublisher.setAttribute('role', 'link');
            append(verifiedPublisher, $('span.extension-verified-publisher-domain', undefined, publisherDomainLink.authority.startsWith('www.') ? publisherDomainLink.authority.substring(4) : publisherDomainLink.authority));
            this.disposables.add(onClick(verifiedPublisher, () => this.openerService.open(publisherDomainLink)));
        }
    }
};
VerifiedPublisherWidget = ( (__decorate([
    ( (__param(2, IHoverService))),
    ( (__param(3, IOpenerService)))
], VerifiedPublisherWidget)));
let SponsorWidget = class SponsorWidget extends ExtensionWidget {
    constructor(container, hoverService, openerService, telemetryService) {
        super();
        this.container = container;
        this.hoverService = hoverService;
        this.openerService = openerService;
        this.telemetryService = telemetryService;
        this.disposables = this._register(( (new DisposableStore())));
        this.render();
    }
    render() {
        reset(this.container);
        this.disposables.clear();
        if (!this.extension?.publisherSponsorLink) {
            return;
        }
        const sponsor = append(this.container, $('span.sponsor.clickable', { tabIndex: 0 }));
        this.disposables.add(this.hoverService.setupUpdatableHover(getDefaultHoverDelegate('mouse'), sponsor, this.extension?.publisherSponsorLink.toString() ?? ''));
        sponsor.setAttribute('role', 'link');
        const sponsorIconElement = renderIcon(sponsorIcon);
        const label = $('span', undefined, ( localizeWithPath(_moduleId, 1, "Sponsor")));
        append(sponsor, sponsorIconElement, label);
        this.disposables.add(onClick(sponsor, () => {
            this.telemetryService.publicLog2('extensionsAction.sponsorExtension', { extensionId: this.extension.identifier.id });
            this.openerService.open(this.extension.publisherSponsorLink);
        }));
    }
};
SponsorWidget = ( (__decorate([
    ( (__param(1, IHoverService))),
    ( (__param(2, IOpenerService))),
    ( (__param(3, ITelemetryService)))
], SponsorWidget)));
let RecommendationWidget = class RecommendationWidget extends ExtensionWidget {
    constructor(parent, extensionRecommendationsService) {
        super();
        this.parent = parent;
        this.extensionRecommendationsService = extensionRecommendationsService;
        this.disposables = this._register(( (new DisposableStore())));
        this.render();
        this._register(toDisposable(() => this.clear()));
        this._register(this.extensionRecommendationsService.onDidChangeRecommendations(() => this.render()));
    }
    clear() {
        if (this.element) {
            this.parent.removeChild(this.element);
        }
        this.element = undefined;
        this.disposables.clear();
    }
    render() {
        this.clear();
        if (!this.extension || this.extension.state === 1  || this.extension.deprecationInfo) {
            return;
        }
        const extRecommendations = this.extensionRecommendationsService.getAllRecommendationsWithReason();
        if (extRecommendations[this.extension.identifier.id.toLowerCase()]) {
            this.element = append(this.parent, $('div.extension-bookmark'));
            const recommendation = append(this.element, $('.recommendation'));
            append(recommendation, $('span' + ThemeIcon.asCSSSelector(ratingIcon)));
        }
    }
};
RecommendationWidget = ( (__decorate([
    ( (__param(1, IExtensionRecommendationsService)))
], RecommendationWidget)));
class PreReleaseBookmarkWidget extends ExtensionWidget {
    constructor(parent) {
        super();
        this.parent = parent;
        this.disposables = this._register(( (new DisposableStore())));
        this.render();
        this._register(toDisposable(() => this.clear()));
    }
    clear() {
        if (this.element) {
            this.parent.removeChild(this.element);
        }
        this.element = undefined;
        this.disposables.clear();
    }
    render() {
        this.clear();
        if (this.extension?.state === 1  ? this.extension.preRelease : this.extension?.hasPreReleaseVersion) {
            this.element = append(this.parent, $('div.extension-bookmark'));
            const preRelease = append(this.element, $('.pre-release'));
            append(preRelease, $('span' + ThemeIcon.asCSSSelector(preReleaseIcon)));
        }
    }
}
let RemoteBadgeWidget = class RemoteBadgeWidget extends ExtensionWidget {
    constructor(parent, tooltip, extensionManagementServerService, instantiationService) {
        super();
        this.tooltip = tooltip;
        this.extensionManagementServerService = extensionManagementServerService;
        this.instantiationService = instantiationService;
        this.remoteBadge = this._register(( (new MutableDisposable())));
        this.element = append(parent, $('.extension-remote-badge-container'));
        this.render();
        this._register(toDisposable(() => this.clear()));
    }
    clear() {
        if (this.remoteBadge.value) {
            this.element.removeChild(this.remoteBadge.value.element);
        }
        this.remoteBadge.clear();
    }
    render() {
        this.clear();
        if (!this.extension || !this.extension.local || !this.extension.server || !(this.extensionManagementServerService.localExtensionManagementServer && this.extensionManagementServerService.remoteExtensionManagementServer) || this.extension.server !== this.extensionManagementServerService.remoteExtensionManagementServer) {
            return;
        }
        this.remoteBadge.value = this.instantiationService.createInstance(RemoteBadge, this.tooltip);
        append(this.element, this.remoteBadge.value.element);
    }
};
RemoteBadgeWidget = ( (__decorate([
    ( (__param(2, IExtensionManagementServerService))),
    ( (__param(3, IInstantiationService)))
], RemoteBadgeWidget)));
let RemoteBadge = class RemoteBadge extends Disposable {
    constructor(tooltip, hoverService, labelService, themeService, extensionManagementServerService) {
        super();
        this.tooltip = tooltip;
        this.labelService = labelService;
        this.themeService = themeService;
        this.extensionManagementServerService = extensionManagementServerService;
        this.element = $('div.extension-badge.extension-remote-badge');
        this.elementHover = this._register(hoverService.setupUpdatableHover(getDefaultHoverDelegate('mouse'), this.element, ''));
        this.render();
    }
    render() {
        append(this.element, $('span' + ThemeIcon.asCSSSelector(remoteIcon)));
        const applyBadgeStyle = () => {
            if (!this.element) {
                return;
            }
            const bgColor = this.themeService.getColorTheme().getColor(EXTENSION_BADGE_REMOTE_BACKGROUND);
            const fgColor = this.themeService.getColorTheme().getColor(EXTENSION_BADGE_REMOTE_FOREGROUND);
            this.element.style.backgroundColor = bgColor ? ( (bgColor.toString())) : '';
            this.element.style.color = fgColor ? ( (fgColor.toString())) : '';
        };
        applyBadgeStyle();
        this._register(this.themeService.onDidColorThemeChange(() => applyBadgeStyle()));
        if (this.tooltip) {
            const updateTitle = () => {
                if (this.element && this.extensionManagementServerService.remoteExtensionManagementServer) {
                    this.elementHover.update(( localizeWithPath(
                        _moduleId,
                        2,
                        "Extension in {0}",
                        this.extensionManagementServerService.remoteExtensionManagementServer.label
                    )));
                }
            };
            this._register(this.labelService.onDidChangeFormatters(() => updateTitle()));
            updateTitle();
        }
    }
};
RemoteBadge = ( (__decorate([
    ( (__param(1, IHoverService))),
    ( (__param(2, ILabelService))),
    ( (__param(3, IThemeService))),
    ( (__param(4, IExtensionManagementServerService)))
], RemoteBadge)));
class ExtensionPackCountWidget extends ExtensionWidget {
    constructor(parent) {
        super();
        this.parent = parent;
        this.render();
        this._register(toDisposable(() => this.clear()));
    }
    clear() {
        this.element?.remove();
    }
    render() {
        this.clear();
        if (!this.extension || !(this.extension.categories?.some(category => category.toLowerCase() === 'extension packs')) || !this.extension.extensionPack.length) {
            return;
        }
        this.element = append(this.parent, $('.extension-badge.extension-pack-badge'));
        const countBadge = ( (new CountBadge(this.element, {}, defaultCountBadgeStyles)));
        countBadge.setCount(this.extension.extensionPack.length);
    }
}
let SyncIgnoredWidget = class SyncIgnoredWidget extends ExtensionWidget {
    constructor(container, configurationService, extensionsWorkbenchService, hoverService, userDataSyncEnablementService) {
        super();
        this.container = container;
        this.configurationService = configurationService;
        this.extensionsWorkbenchService = extensionsWorkbenchService;
        this.hoverService = hoverService;
        this.userDataSyncEnablementService = userDataSyncEnablementService;
        this.disposables = this._register(( (new DisposableStore())));
        this._register(Event.filter(this.configurationService.onDidChangeConfiguration, e => e.affectsConfiguration('settingsSync.ignoredExtensions'))(() => this.render()));
        this._register(userDataSyncEnablementService.onDidChangeEnablement(() => this.update()));
        this.render();
    }
    render() {
        this.disposables.clear();
        this.container.innerText = '';
        if (this.extension && this.extension.state === 1  && this.userDataSyncEnablementService.isEnabled() && this.extensionsWorkbenchService.isExtensionIgnoredToSync(this.extension)) {
            const element = append(this.container, $('span.extension-sync-ignored' + ThemeIcon.asCSSSelector(syncIgnoredIcon)));
            this.disposables.add(this.hoverService.setupUpdatableHover(getDefaultHoverDelegate('mouse'), element, ( localizeWithPath(_moduleId, 3, "This extension is ignored during sync."))));
            element.classList.add(...ThemeIcon.asClassNameArray(syncIgnoredIcon));
        }
    }
};
SyncIgnoredWidget = ( (__decorate([
    ( (__param(1, IConfigurationService))),
    ( (__param(2, IExtensionsWorkbenchService))),
    ( (__param(3, IHoverService))),
    ( (__param(4, IUserDataSyncEnablementService)))
], SyncIgnoredWidget)));
let ExtensionActivationStatusWidget = class ExtensionActivationStatusWidget extends ExtensionWidget {
    constructor(container, small, extensionService, extensionsWorkbenchService) {
        super();
        this.container = container;
        this.small = small;
        this.extensionsWorkbenchService = extensionsWorkbenchService;
        this._register(extensionService.onDidChangeExtensionsStatus(extensions => {
            if (this.extension && ( (extensions.some(e => areSameExtensions({ id: e.value }, this.extension.identifier))))) {
                this.update();
            }
        }));
    }
    render() {
        this.container.innerText = '';
        if (!this.extension) {
            return;
        }
        const extensionStatus = this.extensionsWorkbenchService.getExtensionStatus(this.extension);
        if (!extensionStatus || !extensionStatus.activationTimes) {
            return;
        }
        const activationTime = extensionStatus.activationTimes.codeLoadingTime + extensionStatus.activationTimes.activateCallTime;
        if (this.small) {
            append(this.container, $('span' + ThemeIcon.asCSSSelector(activationTimeIcon)));
            const activationTimeElement = append(this.container, $('span.activationTime'));
            activationTimeElement.textContent = `${activationTime}ms`;
        }
        else {
            const activationTimeElement = append(this.container, $('span.activationTime'));
            activationTimeElement.textContent = `${( localizeWithPath(_moduleId, 4, "Activation time"))}${extensionStatus.activationTimes.activationReason.startup ? ` (${( localizeWithPath(_moduleId, 5, "Startup"))})` : ''} : ${activationTime}ms`;
        }
    }
};
ExtensionActivationStatusWidget = ( (__decorate([
    ( (__param(2, IExtensionService))),
    ( (__param(3, IExtensionsWorkbenchService)))
], ExtensionActivationStatusWidget)));
let ExtensionHoverWidget = ExtensionHoverWidget_1 = class ExtensionHoverWidget extends ExtensionWidget {
    constructor(options, extensionStatusAction, extensionsWorkbenchService, hoverService, configurationService, extensionRecommendationsService, themeService, contextService) {
        super();
        this.options = options;
        this.extensionStatusAction = extensionStatusAction;
        this.extensionsWorkbenchService = extensionsWorkbenchService;
        this.hoverService = hoverService;
        this.configurationService = configurationService;
        this.extensionRecommendationsService = extensionRecommendationsService;
        this.themeService = themeService;
        this.contextService = contextService;
        this.hover = this._register(( (new MutableDisposable())));
    }
    render() {
        this.hover.value = undefined;
        if (this.extension) {
            this.hover.value = this.hoverService.setupUpdatableHover({
                delay: this.configurationService.getValue('workbench.hover.delay'),
                showHover: (options) => {
                    return this.hoverService.showHover({
                        ...options,
                        additionalClasses: ['extension-hover'],
                        position: {
                            hoverPosition: this.options.position(),
                            forcePosition: true,
                        },
                    });
                },
                placement: 'element'
            }, this.options.target, { markdown: () => Promise.resolve(this.getHoverMarkdown()), markdownNotSupportedFallback: undefined });
        }
    }
    getHoverMarkdown() {
        if (!this.extension) {
            return undefined;
        }
        const markdown = ( (new MarkdownString('', { isTrusted: true, supportThemeIcons: true })));
        markdown.appendMarkdown(`**${this.extension.displayName}**`);
        if (semverExports.valid(this.extension.version)) {
            markdown.appendMarkdown(`&nbsp;<span style="background-color:#8080802B;">**&nbsp;_v${this.extension.version}${(this.extension.isPreReleaseVersion ? ' (pre-release)' : '')}_**&nbsp;</span>`);
        }
        markdown.appendText(`\n`);
        if (this.extension.state === 1 ) {
            let addSeparator = false;
            const installLabel = InstallCountWidget.getInstallLabel(this.extension, true);
            if (installLabel) {
                if (addSeparator) {
                    markdown.appendText(`  |  `);
                }
                markdown.appendMarkdown(`$(${installCountIcon.id}) ${installLabel}`);
                addSeparator = true;
            }
            if (this.extension.rating) {
                if (addSeparator) {
                    markdown.appendText(`  |  `);
                }
                const rating = Math.round(this.extension.rating * 2) / 2;
                markdown.appendMarkdown(`$(${starFullIcon.id}) [${rating}](${this.extension.url}&ssr=false#review-details)`);
                addSeparator = true;
            }
            if (this.extension.publisherSponsorLink) {
                if (addSeparator) {
                    markdown.appendText(`  |  `);
                }
                markdown.appendMarkdown(`$(${sponsorIcon.id}) [${( localizeWithPath(_moduleId, 1, "Sponsor"))}](${this.extension.publisherSponsorLink})`);
                addSeparator = true;
            }
            if (addSeparator) {
                markdown.appendText(`\n`);
            }
        }
        const location = this.extension.resourceExtension?.location ?? (this.extension.local?.source === 'resource' ? this.extension.local?.location : undefined);
        if (location) {
            if (this.extension.isWorkspaceScoped && this.contextService.isInsideWorkspace(location)) {
                markdown.appendMarkdown(( localizeWithPath(_moduleId, 6, "Workspace Extension")));
            }
            else {
                markdown.appendMarkdown(( localizeWithPath(_moduleId, 7, "Local Extension")));
            }
            markdown.appendText(`\n`);
        }
        if (this.extension.description) {
            markdown.appendMarkdown(`${this.extension.description}`);
            markdown.appendText(`\n`);
        }
        if (this.extension.publisherDomain?.verified) {
            const bgColor = this.themeService.getColorTheme().getColor(extensionVerifiedPublisherIconColor);
            const publisherVerifiedTooltip = ( localizeWithPath(
                _moduleId,
                8,
                "This publisher has verified ownership of {0}",
                `[${( (URI.parse(this.extension.publisherDomain.link))).authority}](${this.extension.publisherDomain.link})`
            ));
            markdown.appendMarkdown(`<span style="color:${bgColor ? Color.Format.CSS.formatHex(bgColor) : '#ffffff'};">$(${verifiedPublisherIcon.id})</span>&nbsp;${publisherVerifiedTooltip}`);
            markdown.appendText(`\n`);
        }
        if (this.extension.outdated) {
            markdown.appendMarkdown(( localizeWithPath(_moduleId, 9, "Latest version:")));
            markdown.appendMarkdown(`&nbsp;<span style="background-color:#8080802B;">**&nbsp;_v${this.extension.latestVersion}_**&nbsp;</span>`);
            markdown.appendText(`\n`);
        }
        const preReleaseMessage = ExtensionHoverWidget_1.getPreReleaseMessage(this.extension);
        const extensionRuntimeStatus = this.extensionsWorkbenchService.getExtensionStatus(this.extension);
        const extensionStatus = this.extensionStatusAction.status;
        const runtimeState = this.extension.runtimeState;
        const recommendationMessage = this.getRecommendationMessage(this.extension);
        if (extensionRuntimeStatus || extensionStatus || runtimeState || recommendationMessage || preReleaseMessage) {
            markdown.appendMarkdown(`---`);
            markdown.appendText(`\n`);
            if (extensionRuntimeStatus) {
                if (extensionRuntimeStatus.activationTimes) {
                    const activationTime = extensionRuntimeStatus.activationTimes.codeLoadingTime + extensionRuntimeStatus.activationTimes.activateCallTime;
                    markdown.appendMarkdown(`${( localizeWithPath(_moduleId, 4, "Activation time"))}${extensionRuntimeStatus.activationTimes.activationReason.startup ? ` (${( localizeWithPath(_moduleId, 5, "Startup"))})` : ''}: \`${activationTime}ms\``);
                    markdown.appendText(`\n`);
                }
                if (extensionRuntimeStatus.runtimeErrors.length || extensionRuntimeStatus.messages.length) {
                    const hasErrors = extensionRuntimeStatus.runtimeErrors.length || ( (extensionRuntimeStatus.messages.some(message => message.type === Severity$1.Error)));
                    const hasWarnings = ( (extensionRuntimeStatus.messages.some(message => message.type === Severity$1.Warning)));
                    const errorsLink = extensionRuntimeStatus.runtimeErrors.length ? `[${extensionRuntimeStatus.runtimeErrors.length === 1 ? ( localizeWithPath(_moduleId, 10, '1 uncaught error')) : ( localizeWithPath(
                        _moduleId,
                        11,
                        '{0} uncaught errors',
                        extensionRuntimeStatus.runtimeErrors.length
                    ))}](${( (URI.parse(
                        `command:extension.open?${encodeURIComponent(JSON.stringify([this.extension.identifier.id, "features" ]))}`
                    )))})` : undefined;
                    const messageLink = extensionRuntimeStatus.messages.length ? `[${extensionRuntimeStatus.messages.length === 1 ? ( localizeWithPath(_moduleId, 12, '1 message')) : ( localizeWithPath(_moduleId, 13, '{0} messages', extensionRuntimeStatus.messages.length))}](${( (URI.parse(
                        `command:extension.open?${encodeURIComponent(JSON.stringify([this.extension.identifier.id, "features" ]))}`
                    )))})` : undefined;
                    markdown.appendMarkdown(`$(${hasErrors ? errorIcon.id : hasWarnings ? warningIcon.id : infoIcon.id}) This extension has reported `);
                    if (errorsLink && messageLink) {
                        markdown.appendMarkdown(`${errorsLink} and ${messageLink}`);
                    }
                    else {
                        markdown.appendMarkdown(`${errorsLink || messageLink}`);
                    }
                    markdown.appendText(`\n`);
                }
            }
            if (extensionStatus) {
                if (extensionStatus.icon) {
                    markdown.appendMarkdown(`$(${extensionStatus.icon.id})&nbsp;`);
                }
                markdown.appendMarkdown(extensionStatus.message.value);
                if (this.extension.enablementState === 5  && this.extension.local) {
                    markdown.appendMarkdown(`&nbsp;[${( localizeWithPath(_moduleId, 14, "Show Dependencies"))}](${( (URI.parse(
                        `command:extension.open?${encodeURIComponent(JSON.stringify([this.extension.identifier.id, "dependencies" ]))}`
                    )))})`);
                }
                markdown.appendText(`\n`);
            }
            if (runtimeState) {
                markdown.appendMarkdown(`$(${infoIcon.id})&nbsp;`);
                markdown.appendMarkdown(`${runtimeState.reason}`);
                markdown.appendText(`\n`);
            }
            if (preReleaseMessage) {
                const extensionPreReleaseIcon = this.themeService.getColorTheme().getColor(extensionPreReleaseIconColor);
                markdown.appendMarkdown(`<span style="color:${extensionPreReleaseIcon ? Color.Format.CSS.formatHex(extensionPreReleaseIcon) : '#ffffff'};">$(${preReleaseIcon.id})</span>&nbsp;${preReleaseMessage}`);
                markdown.appendText(`\n`);
            }
            if (recommendationMessage) {
                markdown.appendMarkdown(recommendationMessage);
                markdown.appendText(`\n`);
            }
        }
        return markdown;
    }
    getRecommendationMessage(extension) {
        if (extension.state === 1 ) {
            return undefined;
        }
        if (extension.deprecationInfo) {
            return undefined;
        }
        const recommendation = this.extensionRecommendationsService.getAllRecommendationsWithReason()[extension.identifier.id.toLowerCase()];
        if (!recommendation?.reasonText) {
            return undefined;
        }
        const bgColor = this.themeService.getColorTheme().getColor(extensionButtonProminentBackground);
        return `<span style="color:${bgColor ? Color.Format.CSS.formatHex(bgColor) : '#ffffff'};">$(${starEmptyIcon.id})</span>&nbsp;${recommendation.reasonText}`;
    }
    static getPreReleaseMessage(extension) {
        if (!extension.hasPreReleaseVersion) {
            return undefined;
        }
        if (extension.isBuiltin) {
            return undefined;
        }
        if (extension.isPreReleaseVersion) {
            return undefined;
        }
        if (extension.preRelease) {
            return undefined;
        }
        const preReleaseVersionLink = `[${( localizeWithPath(_moduleId, 15, "Pre-Release version"))}](${( (URI.parse(
            `command:workbench.extensions.action.showPreReleaseVersion?${encodeURIComponent(JSON.stringify([extension.identifier.id]))}`
        )))})`;
        return ( localizeWithPath(_moduleId, 16, "This extension has a {0} available", preReleaseVersionLink));
    }
};
ExtensionHoverWidget = ExtensionHoverWidget_1 = ( (__decorate([
    ( (__param(2, IExtensionsWorkbenchService))),
    ( (__param(3, IHoverService))),
    ( (__param(4, IConfigurationService))),
    ( (__param(5, IExtensionRecommendationsService))),
    ( (__param(6, IThemeService))),
    ( (__param(7, IWorkspaceContextService)))
], ExtensionHoverWidget)));
let ExtensionStatusWidget = class ExtensionStatusWidget extends ExtensionWidget {
    constructor(container, extensionStatusAction, openerService) {
        super();
        this.container = container;
        this.extensionStatusAction = extensionStatusAction;
        this.openerService = openerService;
        this.renderDisposables = this._register(( (new MutableDisposable())));
        this._onDidRender = this._register(( (new Emitter())));
        this.onDidRender = this._onDidRender.event;
        this.render();
        this._register(extensionStatusAction.onDidChangeStatus(() => this.render()));
    }
    render() {
        reset(this.container);
        this.renderDisposables.value = undefined;
        const disposables = ( (new DisposableStore()));
        this.renderDisposables.value = disposables;
        const extensionStatus = this.extensionStatusAction.status;
        if (extensionStatus) {
            const markdown = ( (new MarkdownString('', { isTrusted: true, supportThemeIcons: true })));
            if (extensionStatus.icon) {
                markdown.appendMarkdown(`$(${extensionStatus.icon.id})&nbsp;`);
            }
            markdown.appendMarkdown(extensionStatus.message.value);
            const rendered = disposables.add(renderMarkdown(markdown, {
                actionHandler: {
                    callback: (content) => {
                        this.openerService.open(content, { allowCommands: true }).catch(onUnexpectedError);
                    },
                    disposables
                }
            }));
            append(this.container, rendered.element);
        }
        this._onDidRender.fire();
    }
};
ExtensionStatusWidget = ( (__decorate([
    ( (__param(2, IOpenerService)))
], ExtensionStatusWidget)));
let ExtensionRecommendationWidget = class ExtensionRecommendationWidget extends ExtensionWidget {
    constructor(container, extensionRecommendationsService, extensionIgnoredRecommendationsService) {
        super();
        this.container = container;
        this.extensionRecommendationsService = extensionRecommendationsService;
        this.extensionIgnoredRecommendationsService = extensionIgnoredRecommendationsService;
        this._onDidRender = this._register(( (new Emitter())));
        this.onDidRender = this._onDidRender.event;
        this.render();
        this._register(this.extensionRecommendationsService.onDidChangeRecommendations(() => this.render()));
    }
    render() {
        reset(this.container);
        const recommendationStatus = this.getRecommendationStatus();
        if (recommendationStatus) {
            if (recommendationStatus.icon) {
                append(this.container, $(`div${ThemeIcon.asCSSSelector(recommendationStatus.icon)}`));
            }
            append(this.container, $(`div.recommendation-text`, undefined, recommendationStatus.message));
        }
        this._onDidRender.fire();
    }
    getRecommendationStatus() {
        if (!this.extension
            || this.extension.deprecationInfo
            || this.extension.state === 1 ) {
            return undefined;
        }
        const extRecommendations = this.extensionRecommendationsService.getAllRecommendationsWithReason();
        if (extRecommendations[this.extension.identifier.id.toLowerCase()]) {
            const reasonText = extRecommendations[this.extension.identifier.id.toLowerCase()].reasonText;
            if (reasonText) {
                return { icon: starEmptyIcon, message: reasonText };
            }
        }
        else if (this.extensionIgnoredRecommendationsService.globalIgnoredRecommendations.indexOf(this.extension.identifier.id.toLowerCase()) !== -1) {
            return { icon: undefined, message: ( localizeWithPath(
                _moduleId,
                17,
                "You have chosen not to receive recommendations for this extension."
            )) };
        }
        return undefined;
    }
};
ExtensionRecommendationWidget = ( (__decorate([
    ( (__param(1, IExtensionRecommendationsService))),
    ( (__param(2, IExtensionIgnoredRecommendationsService)))
], ExtensionRecommendationWidget)));
const extensionRatingIconColor = registerColor('extensionIcon.starForeground', { light: '#DF6100', dark: '#FF8E00', hcDark: '#FF8E00', hcLight: textLinkForeground }, ( localizeWithPath(_moduleId, 18, "The icon color for extension ratings.")), true);
const extensionVerifiedPublisherIconColor = registerColor('extensionIcon.verifiedForeground', { dark: textLinkForeground, light: textLinkForeground, hcDark: textLinkForeground, hcLight: textLinkForeground }, ( localizeWithPath(_moduleId, 19, "The icon color for extension verified publisher.")), true);
const extensionPreReleaseIconColor = registerColor('extensionIcon.preReleaseForeground', { dark: '#1d9271', light: '#1d9271', hcDark: '#1d9271', hcLight: textLinkForeground }, ( localizeWithPath(_moduleId, 20, "The icon color for pre-release extension.")), true);
registerColor('extensionIcon.sponsorForeground', { light: '#B51E78', dark: '#D758B3', hcDark: null, hcLight: '#B51E78' }, ( localizeWithPath(_moduleId, 21, "The icon color for extension sponsor.")), true);
registerThemingParticipant((theme, collector) => {
    const extensionRatingIcon = theme.getColor(extensionRatingIconColor);
    if (extensionRatingIcon) {
        collector.addRule(`.extension-ratings .codicon-extensions-star-full, .extension-ratings .codicon-extensions-star-half { color: ${extensionRatingIcon}; }`);
        collector.addRule(`.monaco-hover.extension-hover .markdown-hover .hover-contents ${ThemeIcon.asCSSSelector(starFullIcon)} { color: ${extensionRatingIcon}; }`);
    }
    const extensionVerifiedPublisherIcon = theme.getColor(extensionVerifiedPublisherIconColor);
    if (extensionVerifiedPublisherIcon) {
        collector.addRule(`${ThemeIcon.asCSSSelector(verifiedPublisherIcon)} { color: ${extensionVerifiedPublisherIcon}; }`);
    }
    collector.addRule(`.monaco-hover.extension-hover .markdown-hover .hover-contents ${ThemeIcon.asCSSSelector(sponsorIcon)} { color: var(--vscode-extensionIcon-sponsorForeground); }`);
    collector.addRule(`.extension-editor > .header > .details > .subtitle .sponsor ${ThemeIcon.asCSSSelector(sponsorIcon)} { color: var(--vscode-extensionIcon-sponsorForeground); }`);
});

export { ExtensionActivationStatusWidget, ExtensionHoverWidget, ExtensionPackCountWidget, ExtensionRecommendationWidget, ExtensionStatusWidget, ExtensionWidget, InstallCountWidget, PreReleaseBookmarkWidget, RatingsWidget, RecommendationWidget, RemoteBadgeWidget, SponsorWidget, SyncIgnoredWidget, VerifiedPublisherWidget, extensionPreReleaseIconColor, extensionRatingIconColor, extensionVerifiedPublisherIconColor, onClick };
